import { NextSeo } from 'next-seo';
import Head from 'next/head';
import { E2Open } from '/screens/';

export default function E2OpenPage() {
  return (
    <>
      <Head>
        <meta
          name="keywords"
          content="logistics integrations, logistics partners, blue jay"
        />
      </Head>
      <NextSeo
        nofollow={process.env.NOINDEX_FLAG}
        noindex={process.env.NOINDEX_FLAG}
        title="Logistics Partners | e2open"
        description="Our integration with e2open helps you move more with less by delivering real-time market rates and automated booking natively into your e2open transportation management system"
        canonical="https://loadsmart.com/integrations/e2open/"
        openGraph={{
          url: 'https://loadsmart.com/integrations/e2open/',
        }}
      />
      <E2Open />
    </>
  );
}
